import { ProjectType } from 'nekst-api';
import { useProjectTypeHelper } from 'features/tasks-forms';
import TabSelector from '../../../shared/widgets/TabSelector/TabSelector';
import React from 'react';

export function ProjectTypesTabs(
  props: {
    setProjectType: (projectType: ProjectType) => void,
    projectType: ProjectType
    withoutMargin?: boolean
    className?: string
  }
) {
  const projectTypeHelper = useProjectTypeHelper();

  return (
    <TabSelector
      activeOption={props.projectType}
      onSelected={(value) => {
        props.setProjectType(value);
      }}
      options={projectTypeHelper.getTypes()
        .map((item) => ({
          value: item,
          label: projectTypeHelper.getLabel(item)
        }))}
      withoutMargin={props.withoutMargin}
      className={props.className}
    />
  );
}
